// extracted by mini-css-extract-plugin
export default {"container":"gq-z","brandName":"hq-z","productName":"iq-z","productNamePdpEnhancements":"jq-z","breakLongProductName":"kq-z"};